import { Component, OnInit, Input } from '@angular/core';
import { RatingService, Rating } from './rating.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-poi-rating',
  templateUrl: './poi-rating.component.html',
  styleUrls: ['./poi-rating.component.sass']
})
export class PoiRatingComponent implements OnInit {
  @Input() poiId: number
  private sub = new Subscription();
  ratings: Rating[] = [];

  constructor(private ratingService: RatingService) { }

  ngOnInit() {
    this.sub.add(this.ratingService.loadRatings(this.poiId).subscribe(ratings => {
      // console.log(ratings);
      this.ratings = ratings;
    }))
  }

  overallRating(){
    if (this.ratings.length == 0) {
      return 0
    }
    return this.ratings.reduce((sum, current) => sum + current.stars, 0) / this.ratings.length;
  }
}
